"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeImageGenerate = exports.nativeImageGenerateResultSchema = exports.nativeImageGenerateArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.nativeImageGenerateArgsSchema = zod_1.z.object({
    model: zod_1.z
        .enum(['gpt-image-1', 'gpt-image-1.5'])
        .describe('The image generation model to use')
        .nullish(),
    prompt: zod_1.z.string().describe('The prompt for image generation'),
    size: zod_1.z
        .enum(['auto', '1024x1024', '1024x1536', '1536x1024'])
        .describe('The size of the generated image')
        .nullish(),
    filename: zod_1.z
        .string()
        .describe('Optional custom filename for the generated image (without extension)')
        .nullish(),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.nativeImageGenerateResultSchema = zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.literal('image'),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
});
// Tool definition
exports.nativeImageGenerate = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeImageGenerate',
    displayName: 'AI Image Generation',
    displayDescription: 'Generate images using AI',
    category: 'ai',
    color: common_1.BRAND_COLORS.IMAGE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.IMAGE),
    icon: 'image-gen',
    argsSchema: exports.nativeImageGenerateArgsSchema,
}, exports.nativeImageGenerateResultSchema);
